import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-token-cart-list"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_token_cart_item = _resolveComponent("m-token-cart-item")!

  return (_ctx.shopifyCartItems.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.shopifyCartItems.length)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Token Gated Items"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopifyCartItems, (item, idx) => {
          return (_openBlock(), _createBlock(_component_m_token_cart_item, {
            id: item.id,
            key: idx,
            "campaign-id": item.campaignId,
            token: item.token,
            "product-id": item.product_id,
            quantity: item.quantity,
            "product-handle": item.product_handle
          }, null, 8, ["id", "campaign-id", "token", "product-id", "quantity", "product-handle"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}